module.exports = __webpack_public_path__ + "../resources/images/emptyAttachments-2be3ba629c6c331b3ffb212c58d0320f.svg";